import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { t } from 'c-3po';
import { toJS } from '../../helpers/ImmutableToJS';
import { Icon } from '../../ui/icon';

import {
    ERROR_NETWORK_UNAVAILABLE
} from './../../../libs/constants';

// style
import css from './network.sss';

// images
// import CircleCheckIconSvg from './images/circleCheck.icon.svg';
import CircleCrossIconSvg from './images/circleCross.icon.svg';
import RefreshIconSvg from './images/refresh.icon.svg';


class NetworkView extends React.Component {
    state = {
        refreshing: false
    }

    handleReshresh = () => {
        this.setState({
            refreshing: true
        });
        this.props.onReconnect();
    }

    render() {
        const { errors } = this.props;

        return errors[ERROR_NETWORK_UNAVAILABLE] ? (
            <div className={css.root}>
                {this.state.refreshing ? (
                    <div className={css.wrapper}>
                        <div className={css.iconHolder}>
                            <Icon glyph={RefreshIconSvg} className={css.refreshIcon} />
                        </div>
                        <div className={css.textHolder}>
                            {t`Подключаемся к чату...`}
                        </div>
                    </div>
                ) : (
                    <div className={css.wrapper}>
                        <div className={css.iconHolder}>
                            <Icon glyph={CircleCrossIconSvg} className={css.redIcon} />
                        </div>
                        <div className={css.textHolder}>
                            {t`Соединение потеряно`}
                        </div>
                        {/*
                        <div className={css.controls}>
                            <span onClick={this.handleReshresh} className={css.controlLink}>
                                {t`Подключиться`}
                            </span>
                        </div>
                        */}
                    </div>
                )}

                {/*
                <div className={css.wrapper}>
                    <div className={css.iconHolder}>
                        <Icon glyph={CircleCheckIconSvg} className={css.greenIcon} />
                    </div>
                    <div className={css.textHolder}>
                        {t`Соединение восстановлено`}
                    </div>
                </div>
                */}

            </div>
        ) : null;
    }
}


NetworkView.propTypes = {
    errors: PropTypes.object,
    onReconnect: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        errors: state.get('errors'),
    };
};

export const Network = connect(mapStateToProps)(toJS(NetworkView));